import React from "react";

const Card = ({ src, title, description, liveLink, sourceLink }) => {
  return (
    <div className="w-full inline-block mb-5">
      <div className=" text-blue-500 w-full inline-block bg-gray1 shadow-md rounded-lg border-solid border-gray-200 border-2">
        <div
          className="relative items-center flex justify-center max-h-full max-w-full overflow-hidden border-solid border-b-2 border-gray-200 bg-gray1 shadow-md"
          style={{ height: "256px", width: "100%" }}
        >
          <img
            className="h-full w-full block rounded-md"
            src={src}
            style={{ objectFit: "cover" }}
            alt="projectDemo"
          />
        </div>
        <div className="flex flex-col p-3">
          <div
            className="text-lg text-yellow-300 mt-2 mb-5 mr-2 ml-4 text-center italic font-medium"
            style={{ height: "100px" }}
          >
            {title}
            <br />
            <span className="text-base text-white not-italic">
              {description}
            </span>
          </div>
          <div className="flex flex-wrap justify-evenly">
            <a href={liveLink} target="_blank" rel="noreferrer">
              <button className="text-white hover:border-yellow-300 hover:text-yellow-300 cursor-pointer rounded-lg p-1">
                View Live
              </button>
            </a>
            <a href={sourceLink} target="_blank" rel="noreferrer">
              <button className="text-white hover:border-yellow-300 hover:text-yellow-300 cursor-pointer rounded-lg p-1">
                Source Code
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
